// KPI number formatting (locale es-CO). No React.

export function fmtNum(n) {
    return n == null ? '—' : Number(n).toLocaleString('es-CO');
}

export function fmtPct(n) {
    if (n == null) return '—';
    return `${Number(n).toLocaleString('es-CO', { maximumFractionDigits: 1 })}%`;
}
